<div class="input-group typeahead typeahead-lead">
    <ng-template #typeaheadTemplate let-lead="item">
        {{lead.nome}}
        <div class="typeahead-lead-infos">
            {{lead.nomeFantasia}}
            <span *ngIf="lead.fone">
                - <i class="fas fa-phone"></i> {{lead.fone}}
            </span>
            <span *ngIf="lead.celular">
                - <i class="fas fa-mobile-alt"></i> {{lead.celular}}
            </span>
            <span *ngIf="lead.email">
                - <i class="far fa-envelope"></i> {{lead.email}}
            </span>         
        </div>
    </ng-template>   
            
    <!-- <div class="input-group-prepend">
        <span class="input-group-text">

        </span>
    </div>  -->
    <input 
        type="text"
        class="form-control"
        #inputTypeahead

        [typeahead]="typeaheadDataSource"
        [typeaheadWaitMs]="300"
        [typeaheadItemTemplate]="typeaheadTemplate"
        typeaheadOptionField="nome"
        [typeaheadMinLength]="2"
        [typeaheadOptionsLimit]="typeaheadOptionsLimit"
        [typeaheadScrollable]="true"
        [typeaheadOptionsInScrollableView]="typeaheadOptionsInScrollableView"
        [ngModel]="typeaheadSelected"
        (ngModelChange)="typeaheadToken = $event"
        (typeaheadOnSelect)="onSelectEntity($event)"
        (typeaheadNoResults)="onChangeTypeaheadNoResults($event)"
        (typeaheadLoading)="isLoading = $event"
        [container]="container"
        [dropup]="dropup"

        (keyup)="onKeyup($event)"
        (blur)="onBlur()"
        [class.ng-invalid]="ngControl.invalid"
        [required]="required"
        [disabled]="disabled"
        [readonly]="readonly"
        autocomplete="off"
        placeholder="Digite para pesquisar...">

    <span *ngIf="isLoading">
        <i class="fas fa-spinner fa-pulse loading-indicator"></i>
    </span>

    <div class="input-group-append">
        <button type="button" class="btn btn-light" (click)="clear()" tabindex="-1">
            <i class="fas fa-eraser" aria-hidden="true"></i>
        </button>
    </div>

    <div class="dropdown dropdown-menu show" *ngIf="typeaheadNoResults && createWhenNoResults">
        <button type="button" class="dropdown-item active" (click)="create.emit(inputTypeahead.value)">
            <i class="fas fa-plus"></i> Adicionar <strong>{{inputTypeahead.value}}</strong> como um novo lead
        </button>
    </div>
</div>

<p class="form-text text-muted" *ngIf="typeaheadNoResults && !createWhenNoResults">
    Nenhum lead foi encontrado
</p>

<ng-template [ngIf]="entity">
    {{entity.nomeFantasia}} 
    <span *ngIf="entity.fone">
        - <i class="fas fa-phone"></i> {{entity.fone}}
    </span>
    <span *ngIf="entity.celular">
        - <i class="fas fa-mobile-alt"></i> {{entity.celular}}
    </span>
    <span *ngIf="entity.email">
        - <i class="far fa-envelope"></i> {{entity.email}}
    </span>        
</ng-template>